<template>
  <div>
    <FormRegister></FormRegister>
  </div>
</template>

<script>
import FormRegister from "../components/FormRegister";
export default {
  name: "register",
  components: {
    FormRegister,
  },
};
</script>
